// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lGYZh{width:100%;gap:4px}.KJpOa{width:100%;min-height:48px;padding:12px 16px;border:1px solid #d4d4e0;border-radius:8px;cursor:pointer;display:flex;align-items:center}.sbRSY{flex-wrap:wrap}.kcbV6{padding:12px 16px;cursor:pointer}.bkFgN{padding:16px}.bTmoQ{appearance:none;cursor:pointer;display:inline-flex;align-items:center;gap:4px;padding:4px 8px;border:none;border-radius:180px;background:#f4f4f7}.bTmoQ:disabled{cursor:not-allowed}.bZdNr{color:#282863}.eWO53{display:inline-flex;align-items:center;color:#696992}.GGNiv{display:flex;margin-top:10px;padding:0 16px 12px}.PSUKu{position:relative;display:flex;align-items:center;gap:4px;flex:1;min-width:0;overflow:hidden}.YylaS{position:absolute;top:0;left:0;display:flex;gap:4px;visibility:hidden;pointer-events:none;white-space:nowrap}.FGnJt{flex:none;color:#696992}.aTkoy{width:100%}.aTkoy .MuiInputBase-root{height:40px;flex-wrap:nowrap;padding-top:0;padding-bottom:0;overflow:hidden}.aTkoy .MuiAutocomplete-input{flex:1 1 30px;min-width:30px}.aTkoy .MuiInputBase-root:has(.PSUKu) .MuiAutocomplete-input{flex:0 1 30px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"mobileField": `lGYZh`,
	"mobileTrigger": `KJpOa`,
	"mobileChips": `sbRSY`,
	"mobileOption": `kcbV6`,
	"mobileNoOptions": `bkFgN`,
	"designChip": `bTmoQ`,
	"designChipLabel": `bZdNr`,
	"designChipClose": `eWO53`,
	"applyFooter": `GGNiv`,
	"chipsHost": `PSUKu`,
	"chipsMeasure": `YylaS`,
	"overflowCounter": `FGnJt`,
	"field": `aTkoy`
};
export default ___CSS_LOADER_EXPORT___;
